export default __webpack_public_path__ + "static/media/placeholder_business01-fr-web.cf690ab6.png";